import axios from "axios";
export type ReadydesignEntry = {
    Readydesigncode : string;
    Designname : string;
    DesignnameSport : string;
    SaveID : string;
    breitePreview : string;
    hoehePreview : string;
    breite : string;
    hoehe : string;
    urlPrefix : string;
    urlPrefixPreviewResponsive : string;
    urlPrefixProduktseite : string;
    urlPrefixPreview : string;
    imageURL : string;
    Name:string
}
export default {
    namespaced:true,
    state: (
        readyDesigns:ReadydesignEntry[] = []
    ) => ({}),
    getters: {
        getReadyDesigns:(state)=>state.readyDesigns,
    },
    mutations: {
        SET_READYDESIGNS:(state,data)=>state.readyDesigns = data,
    },
    actions: {
        loadReadyDesigns(context, {webproductNormalized, websportNormalized, iso3166}) {
            axios.get("/konfigurator_php/readyDesigns/loadReadyDesigns.php?product="+webproductNormalized+"&sport="+websportNormalized+"&land="+iso3166)
                .then(response=>context.commit("SET_READYDESIGNS", response.data)

            )
        }
    },
}
